import { getUserInfo } from 'helpers/authHelper'
import { updateLiveClassByRoomId } from 'helpers/backendHelpers/liveClass'
import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import logo from '../../assets/images/logo.png'

const LiveClassEnd = () => {
  const { id } = useParams()
  const [classEndModal, setClassEndModal] = useState(false)
  const userInfo = getUserInfo()

  useEffect(() => {
    updateLiveClass(id)
  }, [id])

  const updateLiveClass = async (id) => {
    toggleClassEndModal()
    if (userInfo && userInfo?.userType === 'Teacher') {
      let body = {
        ls_isSessionEnded: 1,
      }

      let response = await updateLiveClassByRoomId(id, body)
      if (response?.status) {
      }
    }
  }

  const toggleClassEndModal = () => {
    setClassEndModal(!classEndModal)
  }

  return (
    <Modal
      isOpen={classEndModal}
      size="lg"
      role="dialog"
      autoFocus={true}
      centered={true}
      className="tutorModal"
      tabIndex="-1"
    >
      <ModalHeader>
        <img src={logo} alt="logo" />
      </ModalHeader>
      <ModalBody className="text-center">
        <h3>Live class ended.</h3>
      </ModalBody>
      <ModalFooter>
        <div>
          <button
            type="button"
            className="cmn--btn w-100"
            onClick={async () => {
              window.parent.location.href = 'https://katondev.in/live-class'
            }}
          >
            <div className="d-flex align-items-center justify-content-center">
              <span>Okay</span>
            </div>
          </button>
        </div>
      </ModalFooter>
    </Modal>
  )
}

export default LiveClassEnd
